/**
 * Error `code` values returned by OMS / inventory for order mutations (GraphQL proxy).
 * OMS rejects add/scan/update/remove lines when the order is not editable with
 * `INVALID_STATE_TRANSITION` (OMS `ApiErrorCode` has no `ALREADY_RESERVED`).
 * Keep in sync with backend `ApiErrorCode` / inventory string codes where applicable.
 */
export enum OrderMutationErrorCode {
  INVALID_STATE_TRANSITION = "INVALID_STATE_TRANSITION",
  /** Other backends (e.g. inventory); not returned by OMS for non-editable-order cart guards. */
  ALREADY_RESERVED = "ALREADY_RESERVED",
  DUPLICATE_ERROR = "DUPLICATE_ERROR",
  CONCURRENCY_ERROR = "CONCURRENCY_ERROR",
  INSUFFICIENT_STOCK = "INSUFFICIENT_STOCK",
  MISSING_ORDER_PAYLOAD = "MISSING_ORDER_PAYLOAD",
  MISSING_SCAN_PAYLOAD = "MISSING_SCAN_PAYLOAD"
}

export function isOrderMutationErrorCode(
  c: string
): c is OrderMutationErrorCode {
  return (Object.values(OrderMutationErrorCode) as string[]).includes(c);
}
